// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1KhIV","header":"PatientQuestionnaire_header__3DXNj","info":"PatientQuestionnaire_info__X1S5C"};